import React from 'react';
// import BtnOneTwenty from './BtnOneTwenty';
import Path from "./config";
import axios from "axios";
// import BtnFiveHundread from './BtnFiveHundread';
// import BtnSevenTwenty from './BtnSevenTwenty';

class PaymentOneTwenty extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sbg_mobile_no: "",
            sbg_email_id: "",
            checked: true,
            ishundread: true,
            amount: "100",
            instructions: '',
            suchi_payment_status: '',
            curuir_payment_status: '',

            suchi_curier_fee: '',
            suchi_fee_status: '',
            suchi_nondani_fee: '',
            suchi_suchi_fee: '',
            suchi_suchifee_status: '',

        }

    }
    componentDidMount() {
        axios.get(Path + 'Suchi_bride_groom_payment_check.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // console.log(response.data)
                this.setState({
                    suchi_payment_status: response.data.suchi_payment_status,
                    curuir_payment_status: response.data.curuir_payment_status
                })
            }.bind(this))

        axios.get(Path + 'suchi_fee_manage_view.php')
            .then((response) => {
                this.setState({
                    suchi_curier_fee: response.data.suchi_curier_fee,
                    suchi_fee_status: response.data.suchi_fee_status,
                    suchi_nondani_fee: response.data.suchi_nondani_fee,
                    suchi_suchi_fee: response.data.suchi_suchi_fee,
                    suchi_suchifee_status: response.data.suchi_suchifee_status,
                    amount: response.data.suchi_nondani_fee
                })
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
        // .then(function () {
        //     // always executed
        // });
    }
    submitSkip1 = (e) => {

        this.props.history.push(`/FormProfile/Nondani`);

    }

    courierCharges = (e) => {
        this.handlePay(e, this.state.suchi_curier_fee, 'courier', this.state.suchi_suchi_fee, this.state.suchi_curier_fee)
    }
    suchiCharges = (e) => {
        this.handlePay(e, this.state.suchi_suchi_fee, 'suchi', this.state.suchi_suchi_fee, this.state.suchi_curier_fee)
    }
    courierSuchiCharges = (e) => {
        if (this.state.suchi_fee_status == '1') {
            let amt = parseInt(this.state.suchi_curier_fee) + parseInt(this.state.suchi_suchi_fee);
            this.handlePay(e, amt, 'courierSuchi', this.state.suchi_suchi_fee, this.state.suchi_curier_fee)
        } else {
            let amt = parseInt(this.state.suchi_curier_fee);
            this.handlePay(e, amt, 'courierSuchi', this.state.suchi_suchi_fee, this.state.suchi_curier_fee)
        }
    }
    handlePay = async (e, amt, feeType, suchi_suchi_fee, suchi_curier_fee) => {
        var options = {
            key: "rzp_live_4LEZFaBCGTkOTY", // Enter the Key ID generated from the Dashboard
            amount: amt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Leva Shubhmangal Business Suchi", //your business name
            description: "Thank You",
            image: '',
            handler: async function (response) {
                // console.log(response);
                if (response.razorpay_payment_id) {
                    // console.log(response)
                    let typee = "Payment";

                    let tempStr = "sbg_payment_amount=" + amt +
                        "&sbg_id=" + localStorage.getItem("userId") +
                        "&type=" + typee +
                        "&feeType=" + feeType +
                        "&suchi_suchi_fee=" + suchi_suchi_fee +
                        "&suchi_curier_fee=" + suchi_curier_fee +
                        "&razorpay_payment_id=" + response.razorpay_payment_id;

                    axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                        .then(function (response) {
                            //console.log(response)
                            if (response.data.status === "updated") {
                                // window.location.replace(`./Nondani`);
                                window.location.reload(false);
                                this.props.history.push(`/FormProfile/Nondani`);
                            } else {
                                alert("Payment not Received");
                            }
                        }.bind(this))
                }
            },
            prefill: {
                name: ' Suchi User', //your customer's name
                email: '',
                contact: '',
            },
            modal: {
                ondismiss() {
                    // Handle what happens when the customer dismisses the payment form without completing the payment. This may
                    // involve re-enabling a "pay now" button if you disable it when it's clicked.
                    //  window.location.replace("/FormProfile/SummaryDetails");
                },
            },
            notes: {
                address: "Razorpay Corporate Office",
            },
            theme: {
                color: "#3399cc",
            },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
        rzp1.on("payment.failed", function (response) {
            //razorpay_payment_id
            // localStorage.setItem("bf_payment_status", "Unpaid");
            // this.props.history.push(`/FormProfile/SummaryDetails`);
        });
    };

    render() {
        return (
            <>
                <div className="container-fluid">
                    <div>
                        {this.state.curuir_payment_status === "paid" && this.state.suchi_payment_status === "0" && this.state.suchi_suchifee_status === "1" ?
                            <div className="row mt-4">
                                <h2> चार्जेस </h2>
                                <div className="col ">
                                    टिप : {this.state.suchi_suchi_fee}
                                </div>
                                <hr></hr>
                                <div className=" mt-4 pl-5">
                                    {/* <BtnFiveHundread /> */}
                                    <button type='button' className='payNowBtn' onClick={(e) => this.suchiCharges(e)}>Pay Now</button>

                                </div>
                            </div>
                            :
                            this.state.suchi_payment_status === "1" && this.state.curuir_payment_status === "not paid"
                                ?
                                <div>
                                    <h2> कुरिअर चार्जेस </h2>
                                    <div className="col " >
                                        टिप : "ही सुची फी नसून हे सुची कुरिअर करण्यासाठीचे चार्जेस ({this.state.suchi_curier_fee}) आहेत.
                                        तुम्हाला सुची कुरिअर ने पाहिजे असल्यास खालील Pay Now वर क्लिक करा"
                                        <br></br>   <b>ज्या वधू-वरांना जळगाव जिल्हा , बुलढाणा , मलकापुर, मोताळा,
                                            नांदुरा परिसरात सूची पाहिजे आहे त्यांना कूरियर व्यवस्था उपलब्ध नाही. त्यांनी त्यांच्या परिसरातील लेवा
                                            शुभमंगल सूची वाटप केंद्र निवडावे.</b><br />
                                    </div>
                                    <hr></hr>
                                    <div className=" mt-4 pl-5">
                                        {/* <BtnOneTwenty /> */}
                                        <button type='button' className='payNowBtn' onClick={(e) => this.courierCharges(e)}>Pay Now</button>
                                    </div>
                                </div>
                                :
                                this.state.suchi_payment_status === "1" && this.state.curuir_payment_status === "paid"
                                    ?
                                    <div>
                                        <div className="col-12 mt-5 center">
                                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitSkip1) ? this.submitSkip1(e) : null}>Skip 📁</button>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <h2> सुची फी व कुरिअर चार्जेस </h2>
                                        <div className="col " >

                                            टिप : {this.state.suchi_fee_status == '1' ?
                                                (' ज्यांनी आधी सुची फी (' + this.state.suchi_suchi_fee + '/-)भरलेली नसेल त्यांनी सूची फी व कुरिअर चार्जेस (' + this.state.suchi_curier_fee + '/-) भरावे.')
                                                : ('कुरिअर चार्जेस (' + this.state.suchi_curier_fee + '/-) भरावे')}
                                            <br></br>   <b>ज्या वधू-वरांना जळगाव जिल्हा , बुलढाणा , मलकापुर, मोताळा, नांदुरा परिसरात सूची पाहिजे आहे त्यांना कूरियर व्यवस्था उपलब्ध नाही. त्यांनी त्यांच्या परिसरातील लेवा शुभमंगल सूची वाटप केंद्र निवडावे.</b><br />

                                        </div>
                                        <hr></hr>
                                        <div className=" mt-4 pl-5">
                                            {/* <BtnSevenTwenty /> */}
                                            <button type='button' className='payNowBtn' onClick={(e) => this.courierSuchiCharges(e)}>Pay Now</button>

                                        </div>
                                    </div>
                        }
                    </div>
                    <br></br>पेमेंट यशस्वी झाल्यावर नोंदणी फॉर्म येण्यासाठी थोडं थांबावं तरीही नोंदणी फॉर्म न उघडल्यास पेमेंट झाल्याचा स्क्रीन शॉट सोबत वधू-वराचे पूर्ण नाव 9730550506 या नंबर वर पाठवून एक कॉल करून कळवावे.
                </div>
            </>
        )
    }
}

export default PaymentOneTwenty

